import { ListPlus } from 'lucide-react';
import { useData, useApp } from '../context.jsx';
import { getCurrentWeekDay } from '../lib/helpers.js';
import { WEEK_DAYS } from '../lib/constants.js';
import { Composer } from '../components/ui.jsx';
import { TaskRow, ChoreDropZone } from '../components/TaskRow.jsx';

export default function Chores() {
  const { data } = useData();
  const { drafts, setDrafts, addItem, removeItem, toggleChore, moveChoreToDay, setChoreCadence } = useApp();
  const columns = ['Daily', ...WEEK_DAYS];

  const choresForColumn = (column) => data.chores
    .filter((item) => column === 'Daily' ? item.cadence === 'Daily' : item.cadence !== 'Daily' && item.weekDay === column)
    .sort((a, b) => `${a.room} ${a.title}`.localeCompare(`${b.room} ${b.title}`));

  return (
    <section className="view-grid">
      <Composer
        icon={ListPlus}
        value={drafts.chore}
        placeholder="Add a chore..."
        onChange={(value) => setDrafts((current) => ({ ...current, chore: value }))}
        onAdd={() => addItem('chores', 'chore', (title) => ({
          id: crypto.randomUUID(),
          title,
          room: '',
          cadence: 'Weekly',
          weekDay: getCurrentWeekDay(),
          streak: 0,
          doneToday: false,
          lastCompletedDate: null
        }))}
      />
      <section className="chore-board wide">
        {columns.map((column) => (
          <ChoreDropZone
            key={column}
            title={column}
            variant={column === 'Daily' ? 'daily' : undefined}
            onDropChore={(id) => moveChoreToDay(id, column)}
          >
            {choresForColumn(column).map((item) => (
              <TaskRow
                key={item.id}
                item={item}
                onToggle={() => toggleChore(item.id)}
                onRemove={() => removeItem('chores', item.id)}
                onCadenceChange={(cadence) => setChoreCadence(item.id, cadence)}
                draggable
              />
            ))}
          </ChoreDropZone>
        ))}
      </section>
    </section>
  );
}
